var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarHalffilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3749 7.53333L12.3416 7.18333L10.7666 3.475C10.4833 2.8 9.5166 2.8 9.23327 3.475L7.65827 7.19167L3.63327 7.53333C2.89994 7.59167 2.59994 8.50833 3.15827 8.99167L6.2166 11.6417L5.29994 15.575C5.13327 16.2917 5.90827 16.8583 6.5416 16.475L9.99994 14.3917L13.4583 16.4833C14.0916 16.8667 14.8666 16.3 14.6999 15.5833L13.7833 11.6417L16.8416 8.99167C17.3999 8.50833 17.1083 7.59167 16.3749 7.53333ZM9.99994 12.8333V5.08333L11.4249 8.45L15.0749 8.76667L12.3083 11.1667L13.1416 14.7333L9.99994 12.8333Z",
    fill: "#7520FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalffilled);
export default __webpack_public_path__ + "static/media/star-halffilled.120321a6ad95eb30c2aa3f626670981e.svg";
export { ForwardRef as ReactComponent };